import InfraRondaMobile from "../../components/InfraRondaMobile";

export const InfraRondaMobilePage = () => <InfraRondaMobile />;
